export default __webpack_public_path__ + "static/undraw_Business_analytics_64el-7ba9e3168b2f84ad4c78fc79445bd76f.svg";